import DataTable, { DataTableProps } from "components/DataTable";
import { BannerContext } from "components/SideBar";
import React, { useContext, useEffect } from "react";
// import { useTranslation } from "react-i18next";

const HolidaysList: React.FC<DataTableProps> = ({
  data,
  columns,
  loading,
  customButton,
  ...rest // 1. Catch all remaining props (including preAddButtons)
}) => {
  useEffect(() => {
    console.log("data, columns ", data, columns);
  }, []);

  // const { t } = useTranslation();
  const { isBannerVisible } = useContext(BannerContext);

  const dynamicHeightClass = isBannerVisible
    ? "h-[calc(100vh-108px)] min-h-[300px]"
    : "h-[calc(100vh-80px)] min-h-[300px]";

  return (
    <DataTable
      heightClass={dynamicHeightClass}
      data={data}
      columns={columns}
      // title={`${t("Holiday")} ${t("List")}`}
      loading={loading}
      customButton={customButton}
      {...rest} 
    />
  );
};

export default HolidaysList;